import type { LoaderFunctionArgs } from 'react-router-dom';
import { getLogger } from '../../libs/logger';
import { getPatientRoomSlugFromPathname } from '../../shared/patientRoom/getPatientRoomSlugFromPathname';
import { prefetchRoomForPatient } from '../../shared/patientRoom/prefetchRoomForPatient';

const logger = getLogger('checkInRoomLoader');

/**
 * Starts getRoomForPatient when a check-in route matches, in parallel with lazy
 * route chunks. Errors are left to useGetRoom (wrong-room redirect, etc.).
 */
export const checkInRoomLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<null> => {
  const slug = getPatientRoomSlugFromPathname(new URL(request.url).pathname);

  if (!slug) {
    return null;
  }

  try {
    await prefetchRoomForPatient(slug);
  } catch (error) {
    logger.warn('check-in room prefetch failed', { slug, error });
  }

  return null;
};
